import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[appScrollHint]',
  standalone: true,
})
export class ScrollHintDirective implements AfterViewInit, OnDestroy {
  private scrollListener: () => void = () => {};
  private readonly hintDissapearingThreshold: number = 64; // px

  @Input() appScrollHintContainerComponent!: HTMLDivElement;
  // @HostBinding('@fadeInOut') animationTrigger = 'enter';

  constructor(
    private hintElement: ElementRef<HTMLDivElement>,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    const el = this.hintElement.nativeElement;
    this.renderer.addClass(el, 'fade-in');
    if (this.appScrollHintContainerComponent) {
      this.scrollListener = this.renderer.listen(
        this.appScrollHintContainerComponent,
        'scroll',
        this.onScroll.bind(this)
      );
    }
  }

  @HostListener('click') onClick() {
    const el = this.hintElement.nativeElement;
    this.renderer.removeClass(el, 'fade-in');
    this.renderer.addClass(el, 'fade-out');
  }

  onScroll(event: Event): void {
    const target = event.target as HTMLElement;
    const scrollHeight = target.scrollHeight;
    const screenViewHeight = target.clientHeight;
    const alreadyScrolled = target.scrollTop;
    const availableForScrolling = scrollHeight - screenViewHeight;
    const shouldBeHidden =
      alreadyScrolled + this.hintDissapearingThreshold > availableForScrolling;

    if (shouldBeHidden) {
      const el = this.hintElement.nativeElement;
      this.renderer.removeClass(el, 'fade-in');
      this.renderer.addClass(el, 'fade-out');
    }
  }

  ngOnDestroy(): void {
    return;
  }
}
